import React, { useMemo } from 'react';

// ── Colori per gruppo ─────────────────────────────────────────────────────────
export const GROUP_COLORS = {
  'Atleta':       { bg: 'rgba(59,130,246,0.20)',  border: 'rgba(59,130,246,0.5)',  text: '#93c5fd' },
  'Tipo azione':  { bg: 'rgba(168,85,247,0.20)',  border: 'rgba(168,85,247,0.5)',  text: '#c4b5fd' },
  'Preset':       { bg: 'rgba(251,191,36,0.20)',  border: 'rgba(251,191,36,0.5)',  text: '#fcd34d' },
  'Esito':        { bg: 'rgba(52,211,153,0.20)',  border: 'rgba(52,211,153,0.5)',  text: '#6ee7b7' },
  'Bersaglio':    { bg: 'rgba(239,68,68,0.20)',   border: 'rgba(239,68,68,0.5)',   text: '#fca5a5' },
  'Biomeccanica': { bg: 'rgba(251,146,60,0.20)',  border: 'rgba(251,146,60,0.5)',  text: '#fdba74' },
  'Tecniche':     { bg: 'rgba(20,184,166,0.20)',  border: 'rgba(20,184,166,0.5)',  text: '#5eead4' },
  'Comandi':      { bg: 'rgba(148,163,184,0.20)', border: 'rgba(148,163,184,0.5)', text: '#cbd5e1' },
  'Video':        { bg: 'rgba(14,165,233,0.20)',  border: 'rgba(14,165,233,0.5)',  text: '#7dd3fc' },
  'Varianti':     { bg: 'rgba(20,184,166,0.12)',  border: 'rgba(20,184,166,0.35)', text: '#99f6e4' },
};

const DEFAULT_COLOR = { bg: 'rgba(255,255,255,0.04)', border: 'rgba(255,255,255,0.08)', text: 'var(--color-text-dim)' };

// ── Definizioni tasti ─────────────────────────────────────────────────────────
// { code, label, w }  — code = e.code value (posizione fisica), w = larghezza in unità
// { gap: true, w }    — spazio visivo senza tasto

const FN_ROW = [
  { code: 'Escape',      label: 'Esc',   w: 1 },
  { gap: true, w: 0.5 },
  { code: 'F1',          label: 'F1',    w: 1 },
  { code: 'F2',          label: 'F2',    w: 1 },
  { code: 'F3',          label: 'F3',    w: 1 },
  { code: 'F4',          label: 'F4',    w: 1 },
  { gap: true, w: 0.5 },
  { code: 'F5',          label: 'F5',    w: 1 },
  { code: 'F6',          label: 'F6',    w: 1 },
  { code: 'F7',          label: 'F7',    w: 1 },
  { code: 'F8',          label: 'F8',    w: 1 },
  { gap: true, w: 0.5 },
  { code: 'F9',          label: 'F9',    w: 1 },
  { code: 'F10',         label: 'F10',   w: 1 },
  { code: 'F11',         label: 'F11',   w: 1 },
  { code: 'F12',         label: 'F12',   w: 1 },
  { gap: true, w: 0.5 },
  { code: 'PrintScreen', label: 'PrtSc', w: 1 },
  { code: 'ScrollLock',  label: 'ScrLk', w: 1 },
  { code: 'Pause',       label: 'Pause', w: 1 },
];

// Cluster nav — 5 righe allineate con le 5 righe principali
const NAV_ROWS = [
  [
    { code: 'Insert',   label: 'Ins',  w: 1 },
    { code: 'Home',     label: 'Home', w: 1 },
    { code: 'PageUp',   label: 'PgUp', w: 1 },
  ],
  [
    { code: 'Delete',   label: 'Del',  w: 1 },
    { code: 'End',      label: 'End',  w: 1 },
    { code: 'PageDown', label: 'PgDn', w: 1 },
  ],
  [{ gap: true, w: 3 }],
  [
    { gap: true, w: 1 },
    { code: 'ArrowUp',    label: '↑', w: 1 },
    { gap: true, w: 1 },
  ],
  [
    { code: 'ArrowLeft',  label: '←', w: 1 },
    { code: 'ArrowDown',  label: '↓', w: 1 },
    { code: 'ArrowRight', label: '→', w: 1 },
  ],
];

// ── ANSI main block (5 righe) ─────────────────────────────────────────────────
const ANSI_MAIN = [
  // Row 0: numeri
  [
    { code: 'Backquote',    label: '`',     w: 1 },
    { code: 'Digit1',       label: '1',     w: 1 },
    { code: 'Digit2',       label: '2',     w: 1 },
    { code: 'Digit3',       label: '3',     w: 1 },
    { code: 'Digit4',       label: '4',     w: 1 },
    { code: 'Digit5',       label: '5',     w: 1 },
    { code: 'Digit6',       label: '6',     w: 1 },
    { code: 'Digit7',       label: '7',     w: 1 },
    { code: 'Digit8',       label: '8',     w: 1 },
    { code: 'Digit9',       label: '9',     w: 1 },
    { code: 'Digit0',       label: '0',     w: 1 },
    { code: 'Minus',        label: '-',     w: 1 },
    { code: 'Equal',        label: '=',     w: 1 },
    { code: 'Backspace',    label: '⌫',     w: 2 },
  ],
  // Row 1: QWERTY
  [
    { code: 'Tab',          label: 'Tab',   w: 1.5 },
    { code: 'KeyQ',         label: 'Q',     w: 1 },
    { code: 'KeyW',         label: 'W',     w: 1 },
    { code: 'KeyE',         label: 'E',     w: 1 },
    { code: 'KeyR',         label: 'R',     w: 1 },
    { code: 'KeyT',         label: 'T',     w: 1 },
    { code: 'KeyY',         label: 'Y',     w: 1 },
    { code: 'KeyU',         label: 'U',     w: 1 },
    { code: 'KeyI',         label: 'I',     w: 1 },
    { code: 'KeyO',         label: 'O',     w: 1 },
    { code: 'KeyP',         label: 'P',     w: 1 },
    { code: 'BracketLeft',  label: '[',     w: 1 },
    { code: 'BracketRight', label: ']',     w: 1 },
    { code: 'Backslash',    label: '\\',    w: 1.5 },
  ],
  // Row 2: ASDF
  [
    { code: 'CapsLock',     label: 'Caps',  w: 1.75 },
    { code: 'KeyA',         label: 'A',     w: 1 },
    { code: 'KeyS',         label: 'S',     w: 1 },
    { code: 'KeyD',         label: 'D',     w: 1 },
    { code: 'KeyF',         label: 'F',     w: 1 },
    { code: 'KeyG',         label: 'G',     w: 1 },
    { code: 'KeyH',         label: 'H',     w: 1 },
    { code: 'KeyJ',         label: 'J',     w: 1 },
    { code: 'KeyK',         label: 'K',     w: 1 },
    { code: 'KeyL',         label: 'L',     w: 1 },
    { code: 'Semicolon',    label: ';',     w: 1 },
    { code: 'Quote',        label: "'",     w: 1 },
    { code: 'Enter',        label: 'Enter', w: 2.25 },
  ],
  // Row 3: ZXCV
  [
    { code: 'ShiftLeft',    label: 'Shift', w: 2.25 },
    { code: 'KeyZ',         label: 'Z',     w: 1 },
    { code: 'KeyX',         label: 'X',     w: 1 },
    { code: 'KeyC',         label: 'C',     w: 1 },
    { code: 'KeyV',         label: 'V',     w: 1 },
    { code: 'KeyB',         label: 'B',     w: 1 },
    { code: 'KeyN',         label: 'N',     w: 1 },
    { code: 'KeyM',         label: 'M',     w: 1 },
    { code: 'Comma',        label: ',',     w: 1 },
    { code: 'Period',       label: '.',     w: 1 },
    { code: 'Slash',        label: '/',     w: 1 },
    { code: 'ShiftRight',   label: 'Shift', w: 2.75 },
  ],
  // Row 4: bottom
  [
    { code: 'ControlLeft',  label: 'Ctrl',  w: 1.25 },
    { code: 'AltLeft',      label: 'Alt',   w: 1.25 },
    { code: 'MetaLeft',     label: 'Cmd',   w: 1.25 },
    { code: 'Space',        label: 'Space', w: 6.25 },
    { code: 'MetaRight',    label: 'Cmd',   w: 1.25 },
    { code: 'AltRight',     label: 'Alt',   w: 1.25 },
    { code: 'ControlRight', label: 'Ctrl',  w: 1.25 },
  ],
];

// ── ISO main block ────────────────────────────────────────────────────────────
// Differenze rispetto ad ANSI:
//   Row 1: Enter piccolo (1.5) al posto di Backslash
//   Row 2: Backslash al posto dell'Enter
//   Row 3: Shift più corto + tasto extra IntlBackslash (<>)
const ISO_MAIN = [
  ANSI_MAIN[0],
  [
    { code: 'Tab',          label: 'Tab',   w: 1.5 },
    { code: 'KeyQ',         label: 'Q',     w: 1 },
    { code: 'KeyW',         label: 'W',     w: 1 },
    { code: 'KeyE',         label: 'E',     w: 1 },
    { code: 'KeyR',         label: 'R',     w: 1 },
    { code: 'KeyT',         label: 'T',     w: 1 },
    { code: 'KeyY',         label: 'Y',     w: 1 },
    { code: 'KeyU',         label: 'U',     w: 1 },
    { code: 'KeyI',         label: 'I',     w: 1 },
    { code: 'KeyO',         label: 'O',     w: 1 },
    { code: 'KeyP',         label: 'P',     w: 1 },
    { code: 'BracketLeft',  label: '[',     w: 1 },
    { code: 'BracketRight', label: ']',     w: 1 },
    { code: 'Enter',        label: '↵',     w: 1.5 },
  ],
  [
    { code: 'CapsLock',     label: 'Caps',  w: 1.75 },
    { code: 'KeyA',         label: 'A',     w: 1 },
    { code: 'KeyS',         label: 'S',     w: 1 },
    { code: 'KeyD',         label: 'D',     w: 1 },
    { code: 'KeyF',         label: 'F',     w: 1 },
    { code: 'KeyG',         label: 'G',     w: 1 },
    { code: 'KeyH',         label: 'H',     w: 1 },
    { code: 'KeyJ',         label: 'J',     w: 1 },
    { code: 'KeyK',         label: 'K',     w: 1 },
    { code: 'KeyL',         label: 'L',     w: 1 },
    { code: 'Semicolon',    label: ';',     w: 1 },
    { code: 'Quote',        label: "'",     w: 1 },
    { code: 'Backslash',    label: '\\',    w: 1 },
  ],
  [
    { code: 'ShiftLeft',      label: 'Shift', w: 1.25 },
    { code: 'IntlBackslash',  label: '<>',    w: 1 },
    { code: 'KeyZ',           label: 'Z',     w: 1 },
    { code: 'KeyX',           label: 'X',     w: 1 },
    { code: 'KeyC',           label: 'C',     w: 1 },
    { code: 'KeyV',           label: 'V',     w: 1 },
    { code: 'KeyB',           label: 'B',     w: 1 },
    { code: 'KeyN',           label: 'N',     w: 1 },
    { code: 'KeyM',           label: 'M',     w: 1 },
    { code: 'Comma',          label: ',',     w: 1 },
    { code: 'Period',         label: '.',     w: 1 },
    { code: 'Slash',          label: '/',     w: 1 },
    { code: 'ShiftRight',     label: 'Shift', w: 1.75 },
  ],
  ANSI_MAIN[4],
];

// ── Helper: renderizza una singola riga di tasti ───────────────────────────────
function KeyRow({ keys, keyToAction, UNIT, GAP }) {
  return (
    <div style={{ display: 'flex', gap: GAP }}>
      {keys.map((keyDef, ki) => {
        if (keyDef.gap) {
          const w = keyDef.w * UNIT + (keyDef.w > 1 ? (keyDef.w - 1) * GAP : 0);
          return <div key={ki} style={{ width: w, flexShrink: 0 }} />;
        }

        const bound = keyToAction[keyDef.code];
        const color = bound ? (GROUP_COLORS[bound.group] || DEFAULT_COLOR) : DEFAULT_COLOR;
        const isBound = !!bound;
        const w = keyDef.w * UNIT + (keyDef.w > 1 ? (keyDef.w - 1) * GAP : 0);

        return (
          <div
            key={ki}
            style={{
              width: w,
              height: 42,
              borderRadius: 5,
              border: `1px solid ${isBound ? color.border : 'rgba(255,255,255,0.08)'}`,
              background: isBound ? color.bg : 'rgba(255,255,255,0.03)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              cursor: 'default',
            }}
            title={isBound ? `${bound.label} (${bound.group})` : keyDef.label}
          >
            {isBound ? (
              <>
                <span style={{
                  fontSize: 10, fontWeight: 700, color: color.text,
                  lineHeight: 1.1, textAlign: 'center',
                  maxWidth: w - 6, overflow: 'hidden',
                  textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                }}>
                  {bound.label}
                </span>
                <span style={{ fontSize: 8, color: 'rgba(255,255,255,0.3)', lineHeight: 1, marginTop: 2 }}>
                  {keyDef.label.length <= 3 ? keyDef.label.toLowerCase() : keyDef.label}
                </span>
              </>
            ) : (
              <span style={{
                fontSize: keyDef.label.length > 4 ? 7 : 10,
                color: 'var(--color-border-hover)', textAlign: 'center',
              }}>
                {keyDef.label}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}

// ── Componente principale ─────────────────────────────────────────────────────
// layout: 'ansi' | 'iso' | 'tkl-ansi' | 'tkl-iso'

function KeyboardLayout({ bindings, actionMap, layout = 'ansi' }) {
  const keyToAction = useMemo(() => {
    const map = {};
    if (!bindings || !actionMap) return map;
    for (const [actionId, code] of Object.entries(bindings)) {
      if (!code) continue;
      const action = actionMap.get(actionId);
      if (action) {
        map[code] = {
          actionId,
          label: action.abbr || action.label,
          group: action.group,
        };
      }
    }
    return map;
  }, [bindings, actionMap]);

  const UNIT = 40;
  const GAP = 3;
  const NAV_GAP = 12;

  const isTKL = layout.startsWith('tkl');
  const mainRows = (layout === 'iso' || layout === 'tkl-iso') ? ISO_MAIN : ANSI_MAIN;

  const rowProps = { keyToAction, UNIT, GAP };

  if (isTKL) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: GAP, userSelect: 'none' }}>
        <KeyRow keys={FN_ROW} {...rowProps} />
        <div style={{ height: 6 }} />
        {mainRows.map((row, ri) => (
          <div key={ri} style={{ display: 'flex', alignItems: 'center', gap: NAV_GAP }}>
            <KeyRow keys={row} {...rowProps} />
            <KeyRow keys={NAV_ROWS[ri]} {...rowProps} />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: GAP, userSelect: 'none' }}>
      {mainRows.map((row, ri) => (
        <KeyRow key={ri} keys={row} {...rowProps} />
      ))}
    </div>
  );
}

export default KeyboardLayout;
